import { render, staticRenderFns } from "./NumbersAndParticipantsCfdChart.vue?vue&type=template&id=c54334fa&scoped=true"
import script from "./NumbersAndParticipantsCfdChart.vue?vue&type=script&lang=js"
export * from "./NumbersAndParticipantsCfdChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54334fa",
  null
  
)

export default component.exports